import { Injectable } from '@angular/core';
import { UUID } from 'angular2-uuid';
import { Observable, Subject } from 'rxjs';

/**
 * Service used to manipulate the map layout.
 */
@Injectable({
	providedIn: 'root'
})
export class MapLayoutService {

	/** Indicates if the map buttons should be disabled. */
	public DisableMapButtons: boolean = false;

	/** Subject for requesting a route plan to be loaded and opened. */
	private readonly loadRoutePlanSubject = new Subject<UUID>();

	/**
	 * Requests a route plan to be loaded and opened by its identifier.
	 * @param routePlanId The route plan identifier to load.
	 */
	public RequestLoadRoutePlan(routePlanId: UUID): void {
		this.loadRoutePlanSubject.next(routePlanId);
	}

	/**
	 * Observable for when a route plan load is requested.
	 * @returns An observable that emits route plan identifiers to load.
	 */
	public OnLoadRoutePlanRequested$(): Observable<UUID> {
		return this.loadRoutePlanSubject.asObservable();
	}
}
